export const environment = {
    quiltSetupTemplateId: 18224, // d8023bde-1174-4e6f-8d77-4c24d669b93d
}
